{
  "title": "Transparency",
  "lead": "Mga budget, ulat, bidding at award, ordinansa at ang mga namumuno — inilathala ng LGU.",
  "tab_documents": "Mga dokumento",
  "tab_bids": "Bidding at award",
  "tab_ordinances": "Mga ordinansa",
  "tab_officials": "Mga opisyal",
  "fdpLead": "Sa ilalim ng Full Disclosure Policy, inilalathala ng mga LGU ang kanilang mga budget, financial report, procurement plan at iba pang mahahalagang dokumento para makita ng lahat.",
  "noDocuments": "Wala pang nailathalang dokumento",
  "noDocumentsBody": "Lalabas dito ang mga dokumento kapag inilathala na ng LGU.",
  "noDocumentsMatch": "Walang dokumentong tugma sa mga filter na ito",
  "moreInCategory": "{count} pa sa aklatan ng dokumento",
  "openLibrary": "Buksan ang aklatan ng dokumento",
  "libraryTitle": "Mga dokumento",
  "libraryLead": "Lahat ng dokumentong inilathala ng LGU. Salain ayon sa uri, taon o opisina.",
  "searchDocuments": "Maghanap ng dokumento",
  "category": "Uri ng dokumento",
  "allCategories": "Lahat ng uri",
  "year": "Taon",
  "allYears": "Lahat ng taon",
  "office": "Opisina",
  "allOffices": "Lahat ng opisina",
  "clearFilters": "I-clear ang mga filter",
  "results": "Mga nahanap na dokumento",
  "backToTransparency": "Bumalik sa Transparency",
  "yearLabel": "Taong {year}",
  "postedOn": "Inilathala {date}",
  "download": "Buksan",
  "downloadSize": "Buksan ({size})",
  "downloadNamed": "Buksan ang {title}",
  "cat_budget": "Budget",
  "cat_financial_reports": "Mga financial report",
  "cat_procurement_plan": "Annual procurement plan",
  "cat_plans_programs": "Mga plano at programa",
  "cat_executive_orders": "Mga executive order",
  "cat_ordinances_resolutions": "Mga ordinansa at resolusyon",
  "cat_forms": "Mga form",
  "cat_reports": "Mga ulat",
  "cat_other": "Iba pa",
  "bidsLead": "Mga proyekto at pagbili na bukas para sa bidding, at kung sino ang nanalo sa mga kontrata.",
  "filterStatus": "Salain ayon sa status",
  "all": "Lahat",
  "bid_open": "Bukas sa bidding",
  "bid_under_evaluation": "Sinusuri",
  "bid_awarded": "Nai-award",
  "bid_failed": "Bigo ang bidding",
  "bid_cancelled": "Kinansela",
  "noBids": "Wala pang naka-post na bidding",
  "noBidsStatus": "Wala sa status na ito",
  "abc": "Aprubadong budget",
  "mode": "Paraan ng procurement",
  "posted": "Inilathala",
  "deadline": "Huling araw ng pagsumite ng bid",
  "deadlineOn": "Huling araw {date}",
  "opening": "Pagbubukas ng bid",
  "awardedTo": "Nai-award kay",
  "philgeps": "PhilGEPS reference",
  "bidDetails": "Mga detalye at dokumento",
  "byOffice": "Inilathala ng {office}",
  "ordinancesLead": "Mga ordinansa at resolusyon ng Sangguniang Bayan, mula paghahain hanggang pag-apruba.",
  "searchOrdinances": "Maghanap ayon sa pamagat, numero o may-akda",
  "filterStage": "Salain ayon sa yugto",
  "state_pending": "Isinasagawa pa",
  "state_final": "Tapos na",
  "noOrdinances": "Wala pang panukala sa tracker",
  "noOrdinancesMatch": "Walang tugmang panukala",
  "kind_ordinance": "Ordinansa",
  "kind_resolution": "Resolusyon",
  "stage_filed": "Naihain",
  "stage_first_reading": "Unang pagbasa",
  "stage_committee": "Nasa komite",
  "stage_public_hearing": "Pampublikong pagdinig",
  "stage_second_reading": "Ikalawang pagbasa",
  "stage_third_reading": "Ikatlong pagbasa",
  "stage_approved": "Inaprubahan",
  "stage_adopted": "Pinagtibay",
  "stage_enacted": "Nilagdaan bilang batas",
  "stage_lapsed": "Naging batas nang walang lagda",
  "stage_vetoed": "Na-veto",
  "authors": "Mga may-akda: {names}",
  "progress": "Pag-usad",
  "done": "tapos",
  "notYet": "hindi pa",
  "history": "Buod at kasaysayan",
  "readText": "Basahin ang buong teksto",
  "noOfficials": "Hindi pa nailalathala ang direktoryo ng mga opisyal",
  "group_elected": "Mga halal na opisyal",
  "group_department_head": "Mga pinuno ng departamento",
  "group_barangay": "Mga opisyal ng barangay",
  "term": "Termino: {from} hanggang {to}",
  "callNamed": "Tawagan si {name}",
  "emailNamed": "I-email si {name}",
  "staffLead": "Ilathala ang mga dokumento, bidding at award ng inyong opisina, at ang mga entry nito sa direktoryo ng mga opisyal. Makikita ito ng mga residente sa Transparency.",
  "noCapability": "Hindi naglalathala rito ang inyong opisina. Itanong sa administrator ng LGU kung dapat.",
  "saved": "Na-save.",
  "hidden": "Nakatago",
  "hide": "Itago",
  "show": "Ipakita",
  "open": "Buksan",
  "visible": "Ipakita sa publiko",
  "currentFile": "Kasalukuyang file",
  "file": "File",
  "fileHint": "PDF o malinaw na scan, hanggang 2 MB pagkatapos i-upload.",
  "fileTooBig": "Masyadong malaki ang file. Gumamit ng PDF na wala pang 12 MB.",
  "chooseFile": "Pumili ng file",
  "replaceFile": "Palitan ang file",
  "uploading": "Ina-upload…",
  "staffDocsLead": "Mga budget, ulat, plano at iba pang dokumentong inilalathala ng inyong opisina para sa publiko.",
  "staffNoDocs": "Wala pang nailathalang dokumento ang inyong opisina",
  "newDocument": "Bagong dokumento",
  "editDocument": "I-edit ang dokumento",
  "docTitle": "Pamagat",
  "postedDate": "Petsa ng paglalathala",
  "description": "Paglalarawan",
  "staffBidsLead": "Mga imbitasyon sa bidding, ang status at mga award nito.",
  "staffNoBids": "Wala pang nai-post na bidding ang inyong opisina",
  "newBid": "Bagong bidding",
  "editBid": "I-edit ang bidding",
  "refNo": "Reference number",
  "status": "Status",
  "bidTitle": "Proyekto o bibilhin",
  "abcPeso": "Aprubadong budget (₱)",
  "modePlaceholder": "hal. Public bidding",
  "awardPeso": "Halaga ng kontrata (₱)",
  "awardedOn": "Petsa ng award",
  "bidDocuments": "Mga dokumento",
  "docLabel": "Pangalan ng dokumento {n}",
  "removeDoc": "Alisin ang {label}",
  "addBidDocument": "Magdagdag ng dokumento",
  "staffOfficialsLead": "Mga opisyal na inililista ng inyong opisina sa pampublikong direktoryo. Gamitin ang mga arrow para ayusin ang pagkakasunod.",
  "staffNoOfficials": "Wala pang nailistang opisyal ang inyong opisina",
  "newOfficial": "Bagong opisyal",
  "editOfficial": "I-edit ang opisyal",
  "personName": "Pangalan",
  "position": "Posisyon",
  "positionPlaceholder": "hal. Municipal Treasurer",
  "groupField": "Grupo",
  "linkedOffice": "Opisinang pinamumunuan o kinabibilangan",
  "noOffice": "Wala",
  "termStart": "Simula ng termino",
  "termEnd": "Pagtatapos ng termino",
  "publicEmail": "Pampublikong email",
  "publicPhone": "Pampublikong telepono",
  "photo": "Larawan",
  "photoHint": "Opsiyonal. Opisyal na larawan; hindi ipinapakita sa low-data mode.",
  "photoAlt": "Larawan ni {name}",
  "addPhoto": "Magdagdag ng larawan",
  "replacePhoto": "Palitan ang larawan",
  "removePhoto": "Alisin ang larawan",
  "moveUp": "Iakyat si {name}",
  "moveDown": "Ibaba si {name}",
  "staffOrdinancesLead": "Subaybayan ang bawat ordinansa at resolusyon mula paghahain hanggang pag-apruba. Sinusundan ng mga residente ang mga yugto sa pahinang Transparency.",
  "staffNoOrdinances": "Wala pang panukala sa tracker",
  "newOrdinance": "Bagong panukala",
  "editOrdinance": "I-edit ang panukala",
  "kind": "Uri",
  "number": "Numero",
  "numberHint": "Kapag mayroon na, hal. Ordinance No. 12, s. 2026.",
  "ordTitle": "Pamagat",
  "authorsField": "Mga may-akda o sponsor",
  "summary": "Buod",
  "ordFile": "Buong teksto",
  "ordFileHint": "Opsiyonal. PDF ng panukala gaya ng naihain o naaprubahan.",
  "stagesTitle": "Mga yugto",
  "stagesHint": "Magsimula sa petsa ng paghahain. Idagdag ang bawat hakbang habang nangyayari; inaayos ang mga ito ayon sa petsa.",
  "stageN": "Yugto {n}",
  "stage": "Yugto",
  "stageDate": "Petsa",
  "committee": "Komite",
  "hearingTime": "Oras",
  "venue": "Lugar",
  "stageNote": "Paalala",
  "removeStage": "Alisin ang yugtong ito",
  "addStage": "Idagdag ang susunod na yugto",
  "lastAction": "Huling aksyon {date}",
  "showingFor": "Ipinapakita ang resulta para sa “{q}”.",
  "showAll": "Ipakita lahat"
}
